module.exports = __webpack_public_path__ + "static/img/专题活动页设计-平面合成类活动页.3c37448.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/goods/CPK10002/专题活动页设计-平面合成类活动页.png
// module id = I0gG
// module chunks = 1